const formattingDate = (date: string): string => {
  const targetDate = date ? new Date(date) : new Date();

  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, "0");
  const day = String(targetDate.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const makeTimeRange = (baseDate?: string | string[]) => {
  if (typeof baseDate === "string") {
    return `
      timeRange: { 
        endDate: "${formattingDate(baseDate)}", 
        rangeLength: 1, rangeLengthUnit: Y 
      }
    `;
  }

  const startDate = baseDate?.[0];
  const endDate = baseDate?.[1];

  if (!startDate)
    return `
      timeRange: { 
        endDate: "${formattingDate(endDate ?? "")}", 
        rangeLength: 1, rangeLengthUnit: Y 
      }
    `;

  if (!endDate)
    return `
      timeRange: { 
        startDate: "${formattingDate(startDate)}", 
        endDate: "${formattingDate(endDate ?? "")}", 
      }
    `;

  return `
  timeRange: { 
      ${`startDate: "${formattingDate(startDate)}"`}
      ${`endDate: "${formattingDate(endDate)}"`}
    }
  `;
};
